export default __webpack_public_path__ + "static/portfolio-8-72a58aad5bbf8e35a1929673c66d5dd0.jpg";